import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { Toaster } from '@/components/ui/sonner';
import ErrorBoundary from '@/components/ErrorBoundary';
import '@/App.css';

import LandingPage from '@/pages/LandingPage';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import ClientesPage from '@/pages/ClientesPage';
import MateriaisPage from '@/pages/MateriaisPage';
import AutoclavesPage from '@/pages/AutoclavesPage';
import CiclosPage from '@/pages/CiclosPage';
import RecepcaoPage from '@/pages/RecepcaoPage';
import MontagemPage from '@/pages/MontagemPage';
import RelatoriosPage from '@/pages/RelatoriosPage';
import ConfiguracoesPage from '@/pages/ConfiguracoesPage';
import ConsultaPublicaPage from '@/pages/ConsultaPublicaPage';
import ConsultaClientePage from '@/pages/ConsultaClientePage';
import RastreamentoClientePage from '@/pages/RastreamentoClientePage';
import ArsenalPage from '@/pages/ArsenalPage';
import UsuariosPage from '@/pages/UsuariosPage';
import AgendamentosPage from '@/pages/AgendamentosPage';
import POPPage from '@/pages/POPPage';
import SchedulerPage from '@/pages/SchedulerPage';
import FinanceiroPage from '@/pages/FinanceiroPage';
import EstoquePage from '@/pages/EstoquePage';
import RHPage from '@/pages/RHPage';
import PortalClientePage from '@/pages/PortalClientePage';
import SolicitacoesPage from '@/pages/SolicitacoesPage';
import VigilanciaPage from '@/pages/VigilanciaPage';
import RelatorioCiclosPage from '@/pages/RelatorioCiclosPage';
import DashboardLayout from '@/components/DashboardLayout';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-slate-600">Carregando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/consulta/:cicloId" element={<ConsultaPublicaPage />} />
      <Route path="/consulta-cliente" element={<ConsultaClientePage />} />
      <Route path="/rastrear/:clienteId" element={<RastreamentoClientePage />} />
      <Route path="/portal" element={<PortalClientePage />} />
      <Route path="/vigilancia" element={<VigilanciaPage />} />

      {/* Protected Routes with Layout */}
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/clientes" element={<ClientesPage />} />
        <Route path="/materiais" element={<MateriaisPage />} />
        <Route path="/autoclaves" element={<AutoclavesPage />} />
        <Route path="/recepcao" element={<RecepcaoPage />} />
        <Route path="/montagem" element={<MontagemPage />} />
        <Route path="/ciclos" element={<CiclosPage />} />
        <Route path="/arsenal" element={<ArsenalPage />} />
        <Route path="/relatorio-ciclos" element={<RelatorioCiclosPage />} />
        <Route path="/agendamentos" element={<AgendamentosPage />} />
        <Route path="/relatorios" element={<RelatoriosPage />} />
        <Route path="/pop" element={<POPPage />} />
        <Route path="/usuarios" element={<UsuariosPage />} />
        <Route path="/configuracoes" element={<ConfiguracoesPage />} />
        <Route path="/scheduler" element={<SchedulerPage />} />
        <Route path="/financeiro" element={<FinanceiroPage />} />
        <Route path="/estoque" element={<EstoquePage />} />
        <Route path="/rh" element={<RHPage />} />
        <Route path="/solicitacoes" element={<SolicitacoesPage />} />
      </Route>

      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;